import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./style";
import App from "components/App";
import {LocaleProvider} from "./context/LocaleContext";

// locale.setLocale('en');

ReactDOM.render(
	<Provider store={store}>
        <LocaleProvider>
            <Router basename="/cp/">
                <Route path="/" component={App} />
            </Router>
        </LocaleProvider>
	</Provider>,
	document.getElementById('root')
);
